import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShowReportsPanel } from "../../../../redux/action/Dashboard-action";
import { getLayerReports, sortReports } from "../../../../utils/helper";
import FeatureCard from "../../../FeatureCard";
import ReportEditor from "./ReportEditor/ReportEditor";
import {
  StyledCardsContainer,
  StyledHeader,
  StyledHeaderButton,
  StyledHeaderTitle,
  StyledReportsContainer,
} from "./Reports-styled";

const Reports = ({ config, t }) => {
  const [localEditableLayer, setEditableLayer] = useState();
  const [localEditableFeature, setEditableFeature] = useState(null);
  const reportsLayer = useSelector((state) => state.dashboard.reportsLayer);
  const dispatch = useDispatch();

  useEffect(() => {
    setEditableLayer(reportsLayer);
  }, [reportsLayer]);

  const reportsLayerMap = useSelector(
    (state) => state.dashboard.reportsLayerMap
  );
  const reportedFeature = useSelector(
    (state) => state.dashboard.reportedFeature
  );

  const filters = useSelector((state) => state.filters);
  const activeModule = useSelector((state) => state.activeModule);

  const editableLayer = useSelector((state) => state.dashboard.editableLayer);

  const reports = useMemo(() => {
    if (Object.keys(reportsLayerMap || {}).length === 0) return [];
    const filtersArray = filters[activeModule]?.currvalidationfield || [];
    const hasReportFilters = "currvalidationfield" in filters[activeModule];

    if (!reportedFeature || !editableLayer) return [];

    const featureId = reportedFeature.getObjectId();
    const features = getLayerReports(editableLayer, reportsLayerMap);

    return features.filter(
      (f) =>
        f.attributes?.reportedfeatureid === featureId &&
        (hasReportFilters
          ? filtersArray.includes(f.attributes?.currvalidationfield)
          : true)
    );
  }, [reportsLayerMap, reportedFeature, editableLayer, filters, activeModule]);

  const closePanel = useCallback(() => {
    dispatch(setShowReportsPanel(false));
  }, []);

  const sortedReports = useMemo(() => {
    return sortReports(reports, reportsLayer);
  }, [reports, reportsLayer]);

  if (reports.length === 0) return null;

  return (
    <StyledReportsContainer>
      {!localEditableFeature && (
        <StyledHeader>
          <StyledHeaderTitle>
            {t("screen.widget.Editor.manager.reports.updatesKpiTitle")}
          </StyledHeaderTitle>
          <StyledHeaderButton onClick={closePanel}>
            <svg
              fillRule="evenodd"
              role="img"
              viewBox="0 0 10 10"
              aria-label="description"
              fill="var(--fontColor)"
              width="100%"
              height="100%"
            >
              <path d="M6.32 5L10 8.68 8.68 10 5 6.32 1.32 10 0 8.68 3.68 5 0 1.32 1.32 0 5 3.68 8.68 0 10 1.32 6.32 5z"></path>
            </svg>
          </StyledHeaderButton>
        </StyledHeader>
      )}
      <StyledCardsContainer hasPadding={!localEditableFeature}>
        {localEditableFeature ? (
          <ReportEditor
            t={t}
            config={config}
            setEditableFeature={setEditableFeature}
            setEditableLayer={setEditableLayer}
            editableLayer={localEditableLayer}
            editableFeature={localEditableFeature}
            onClose={closePanel}
          />
        ) : (
          sortedReports.map((feature) => {
            const key = feature.reports
              ? `${feature.getObjectId()}-reports-${feature.reports.length}`
              : `${feature.getObjectId()}`;
            return (
              <FeatureCard
                key={key}
                layer={reportsLayer}
                feature={feature}
                onEdit={() => {
                  setEditableLayer(reportsLayer);
                  setEditableFeature(feature);
                }}
                additionalFields={[
                  "fpname",
                  "fporganisation",
                  "fpphone",
                  "fpemail",
                ]}
                isUpdate
              />
            );
          })
        )}
      </StyledCardsContainer>
    </StyledReportsContainer>
  );
};

export default Reports;
